import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { TooltipTypography, Typography } from "@faire/web--source/slate/Typography";
import parse, { Element } from "html-react-parser";
import React from "react";
export var TextWithTooltip = function(param) {
    var text = param.text, textColor = param.textColor, tooltipText = param.tooltipText, tooltipTypographyVariant = param.tooltipTypographyVariant, tooltipPosition = param.tooltipPosition, tooltipWidth = param.tooltipWidth;
    var transform = function(node) {
        if (node instanceof Element && (node.name === "b" || node.name === "u" || node.name === "span")) {
            var targetText = node.children[0].data;
            return /*#__PURE__*/ _jsx(Tooltip, {
                targetNode: /*#__PURE__*/ _jsx(TooltipTypography, {
                    variant: tooltipTypographyVariant,
                    color: textColor,
                    children: targetText
                }),
                contents: [
                    {
                        body: tooltipText
                    }
                ],
                position: tooltipPosition,
                width: tooltipWidth
            });
        }
        return undefined;
    };
    return /*#__PURE__*/ _jsx(Typography, {
        as: "span",
        color: textColor,
        children: parse(text, {
            replace: transform
        })
    });
};
